import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import { CardActions, useTheme } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import { TT_GO_TO_DEVICE_SUMMARY } from "../../../constants/tooltips"
import { SINGLE_GEN_DEVICE_NAV_LINK } from "../../../router/routes"
import { TDevicesToInstall } from "../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import AppButton from "../../buttons/appButton"
import VerticalKeyValueList from "../../dataDisplay/verticalKeyValueList"
import AppTooltip from "../../helper/appTooltip"
import LctAvatar from "../../pills/lct/lctAvatar"
import { LCT_METADATA_DISPATCHER } from "../../pills/lct/lctMetadataDispatcher"
import { AppCard, AppCardHeader, AppCardContent } from "../../surfaces/appCard"

interface IGenerationGeneralDeviceProps {
    deviceReference: string
    deviceType: string
    deviceSysRef: string
    details: TDevicesToInstall
}

/**
 * Card for displaying details about an proposed generation general device
 * at a property. Designed for use on the single application summary page.
 * This component has been designed to be schema version agnostic. It picks
 * of a number of core fields and ingests the rest via the generic `details`.
 * object.
 */
const GenerationGeneralDevice = ({
    deviceReference,
    deviceType,
    deviceSysRef,
    details,
}: IGenerationGeneralDeviceProps): ReactElement => {
    const navigate = useNavigate()
    const theme = useTheme()
    return (
        <AppCard
            sx={{ backgroundColor: theme.palette.background.contentBackground }}
        >
            <AppCardHeader
                title={deviceReference}
                subheader={LCT_METADATA_DISPATCHER[deviceType]?.label}
                avatar={<LctAvatar lcts={[deviceType]} />}
            />
            <AppCardContent>
                <VerticalKeyValueList kwargs={details} />
            </AppCardContent>
            <CardActions sx={{ justifyContent: "flex-end" }}>
                <AppTooltip title={TT_GO_TO_DEVICE_SUMMARY}>
                    <AppButton
                        variant="outlined"
                        onClick={() =>
                            navigate(SINGLE_GEN_DEVICE_NAV_LINK(deviceSysRef))
                        }
                        endIcon={<NavigateNextIcon />}
                    >
                        View Device Details
                    </AppButton>
                </AppTooltip>
            </CardActions>
        </AppCard>
    )
}

export default GenerationGeneralDevice
